import { useMutation, useQueryClient } from '@tanstack/react-query';

import UserStore from 'src/app_deprecated/stores/UserStore';

import { postData } from 'src/app/queries';

import { marketingTemplateQueryKey } from './get-campaign-template';

import type { MarketingTemplatePreset } from './get-campaign-templates';

export const SAVE_CAMPAIGN_TEMPLATE = 'api/marketing-template/upsert-template-preset';

type SaveCampaignTemplatePayload = {
  Template: MarketingTemplatePreset;
};

type SaveCampaignTemplateResponse = {
  LastModifiedDateUtc: string;
  MarketingTemplatePresetId: number;
};

export function useSaveCampaignTemplateMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: MarketingTemplatePreset) => {
      const userApiData = UserStore.getApiData(payload);
      const payloadWithLSP = {
        Template: { ...payload, LspId: userApiData.LspId },
      };
      const res = postData<SaveCampaignTemplatePayload, SaveCampaignTemplateResponse>({
        endpoint: SAVE_CAMPAIGN_TEMPLATE,
        payload: payloadWithLSP,
      });
      return res;
    },
    onSuccess: () => queryClient.invalidateQueries(marketingTemplateQueryKey),
  });
}
